module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "address-selector-wrapper"
  }, [_c('el-popover', {
    attrs: {
      "placement": "bottom-start",
      "width": "380",
      "trigger": "click",
      "popper-class": "address-selector-popover"
    },
    scopedSlots: _vm._u([{
      key: "reference",
      fn: function() {
        return [_c('el-button', {
          staticClass: "select-address-btn",
          attrs: {
            "size": "small",
            "type": "primary",
            "disabled": !_vm.customerId,
            "icon": "el-icon-location-outline"
          }
        }, [_vm._v("\n        选择地址\n      ")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.popoverVisible),
      callback: function($$v) {
        _vm.popoverVisible = $$v
      },
      expression: "popoverVisible"
    }
  }, [_vm._v(" "), (_vm.customerId) ? _c('el-alert', {
    staticClass: "top-tip",
    attrs: {
      "title": "选择客户地址，快速导入到订单收货地址栏中，导入后仍可手动修改。",
      "type": "info",
      "show-icon": "",
      "closable": false
    }
  }) : _vm._e(), _vm._v(" "), (_vm.customerId) ? _c('div', {
    staticClass: "selector-options"
  }, [_c('div', {
    staticClass: "checkbox-group"
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.includeName),
      callback: function($$v) {
        _vm.includeName = $$v
      },
      expression: "includeName"
    }
  }, [_vm._v("导入姓名")]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.includePhone),
      callback: function($$v) {
        _vm.includePhone = $$v
      },
      expression: "includePhone"
    }
  }, [_vm._v("导入电话")])], 1), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "选择后将自动填入地址字段，可选导入电话与姓名",
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "icon": "el-icon-info",
      "size": "mini"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.customerId) ? _c('div', {
    staticClass: "no-customer-tip"
  }, [_vm._v("\n      请先选择客户信息后再选择地址\n    ")]) : _vm._e(), _vm._v(" "), (_vm.customerId) ? _c('div', {
    staticClass: "address-list scroll-wrapper"
  }, [_c('el-scrollbar', _vm._l((_vm.addressList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "address-card",
      on: {
        "click": function($event) {
          return _vm.selectAddress(item)
        }
      }
    }, [_c('div', {
      staticClass: "card-header"
    }, [_c('div', {
      staticClass: "card-name-phone"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "phone"
    }, [_vm._v(_vm._s(item.telNum))])]), _vm._v(" "), (item.type === '常用') ? _c('el-tag', {
      staticClass: "common-tag",
      attrs: {
        "size": "mini",
        "type": "success"
      }
    }, [_vm._v("常用")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "card-address"
    }, [_vm._v("\n            " + _vm._s(_vm.formatFullAddress(item)) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "card-operator"
    }, [_vm._v("\n            创建人：" + _vm._s(item.operatorName || '未知') + "\n          ")])])
  }), 0), _vm._v(" "), (_vm.addressList.length === 0) ? _c('el-empty', {
    staticClass: "empty-box",
    attrs: {
      "description": "暂无地址"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.addressVisible = true
      }
    }
  }, [_vm._v("\n        立即创建\n      ")])], 1) : _vm._e()], 1), _vm._v(" "), _c('customer-address', {
    attrs: {
      "visible": _vm.addressVisible,
      "customer-id": _vm.customerId
    },
    on: {
      "update:visible": function($event) {
        _vm.addressVisible = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54dcb6c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/customerMag/addressSelector.vue
// module id = 1011
// module chunks = 3